module.exports = __webpack_public_path__ + "static/media/BallMill_1.447eff6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/BallMill_1.jpg
// module id = 420
// module chunks = 0